function timestamp(value) {
  if (value === null || value === undefined || value === '') return 0
  const time = typeof value === 'number' ? value : new Date(value).getTime()
  return Number.isFinite(time) ? time : 0
}

function unionSeconds(intervals) {
  let total = 0
  let end = 0
  intervals.slice().sort((a, b) => a[0] - b[0]).forEach(([start, finish]) => {
    total += Math.max(0, finish - Math.max(start, end))
    end = Math.max(end, finish)
  })
  return Math.floor(total / 1000)
}

function buildJointPlayback(entries, now = Date.now(), parkingMinMinutes = 10) {
  const pointMap = new Map()
  const intervals = []
  const parkingPoints = []
  const events = []
  const starts = []
  const ends = []
  const orders = entries.map(entry => {
    const waybill = entry.waybill || {}
    const waybillNo = waybill.waybillNo || waybill.transportNo
    const monitorData = entry.monitorData || {}
    const tracks = (monitorData.tracks || []).filter(item => timestamp(item.locationTime) && item.longitude !== null && item.longitude !== undefined && item.latitude !== null && item.latitude !== undefined && Number.isFinite(Number(item.longitude)) && Number.isFinite(Number(item.latitude))).slice().sort((a, b) => timestamp(a.locationTime) - timestamp(b.locationTime))
    let parkingStart = null
    let parkingSeconds = 0
    let drivingSeconds = 0
    const orderParking = []
    const finishParking = endPoint => {
      if (parkingStart === null) return
      const startTime = timestamp(tracks[parkingStart].locationTime)
      const endTime = timestamp(endPoint.locationTime)
      if (endTime - startTime > parkingMinMinutes * 60000) {
        orderParking.push({ ...endPoint, key: `${waybillNo}-${startTime}`, waybillNo, startTime, endTime, duration: (endTime - startTime) / 1000 })
      }
      parkingStart = null
    }
    tracks.forEach((track, index) => {
      const time = timestamp(track.locationTime)
      const key = `${time}|${Number(track.longitude)}|${Number(track.latitude)}`
      if (pointMap.has(key)) {
        const saved = pointMap.get(key)
        if (!saved.waybillNos.includes(waybillNo)) saved.waybillNos.push(waybillNo)
      } else pointMap.set(key, { ...track, waybillNo, waybillNos: [waybillNo] })
      if (!index) return
      const previous = tracks[index - 1]
      const seconds = Math.max(0, (time - timestamp(previous.locationTime)) / 1000)
      intervals.push([timestamp(previous.locationTime), time])
      if ((Number(previous.speed) || 0) <= 5) {
        parkingSeconds += seconds
        if (parkingStart === null) parkingStart = index - 1
      } else {
        drivingSeconds += seconds
        finishParking(previous)
      }
    })
    if (tracks.length) finishParking(tracks[tracks.length - 1])
    parkingPoints.push(...orderParking)
    ;(entry.events || []).forEach(event => events.push({ ...event, waybillNo }))
    const start = timestamp(waybill.actualDepartTime || waybill.createTime)
    const end = Number(waybill.transportStatus) === 1 ? now : timestamp(waybill.actualArriveTime || waybill.finishRequestedTime) || timestamp(tracks.length && tracks[tracks.length - 1].locationTime)
    if (start) starts.push(start)
    if (end) ends.push(end)
    const distance = summarizeWaybillTracks(tracks, monitorData.monitor && monitorData.monitor.drivenDistance).distance
    return { ...entry, waybill, monitorData, waybillNo, distance, parkingPoints: orderParking, parkingSeconds, drivingSeconds }
  })
  const tracks = Array.from(pointMap.values()).sort((a, b) => timestamp(a.locationTime) - timestamp(b.locationTime))
  let segment = 0
  tracks.forEach((track, index) => {
    const previous = tracks[index - 1]
    // 没有共同所属单的相邻采样必须断开，禁止补出两单之间的行驶路线。
    if (previous && !track.waybillNos.some(no => previous.waybillNos.includes(no))) segment += 1
    track.segmentKey = String(segment)
  })
  return {
    orders,
    tracks,
    parkingPoints: parkingPoints.sort((a, b) => a.startTime - b.startTime),
    events: events.sort((a, b) => timestamp(a.eventTime) - timestamp(b.eventTime)),
    distance: orders.length && orders.every(item => item.distance !== null) ? orders.reduce((sum, item) => sum + item.distance, 0) : null,
    totalSeconds: unionSeconds(intervals),
    range: { startTime: starts.length ? Math.min(...starts) : 0, endTime: ends.length ? Math.max(...ends) : 0 }
  }
}

function locateJointPlayback(tracks, ratio) {
  if (!tracks.length) return null
  const firstTime = Number(tracks[0].gpsTime)
  const target = firstTime + Math.max(0, Math.min(1, ratio)) * (Number(tracks[tracks.length - 1].gpsTime) - firstTime)
  let index = 0
  while (index + 1 < tracks.length && Number(tracks[index + 1].gpsTime) <= target) index += 1
  const current = tracks[index]
  const next = tracks[index + 1]
  const canInterpolate = next && current.segmentKey === next.segmentKey && Number(next.gpsTime) > Number(current.gpsTime)
  const part = canInterpolate ? (target - Number(current.gpsTime)) / (Number(next.gpsTime) - Number(current.gpsTime)) : 0
  return { trackIndex: index, navigatorRatio: tracks.length > 1 ? (index + part) / (tracks.length - 1) : 0, position: [Number(current.lon) + (canInterpolate ? (Number(next.lon) - Number(current.lon)) * part : 0), Number(current.lat) + (canInterpolate ? (Number(next.lat) - Number(current.lat)) * part : 0)] }
}

function jointNavigatorTimeRatio(tracks, ratio) {
  if (tracks.length < 2) return 0
  const position = Math.max(0, Math.min(1, ratio)) * (tracks.length - 1)
  const index = Math.floor(position)
  const current = Number(tracks[index].gpsTime)
  const next = Number((tracks[index + 1] || tracks[index]).gpsTime)
  const start = Number(tracks[0].gpsTime)
  const duration = Number(tracks[tracks.length - 1].gpsTime) - start
  return duration > 0 ? (current + (next - current) * (position - index) - start) / duration : 0
}

module.exports = { buildJointPlayback, locateJointPlayback, jointNavigatorTimeRatio }
const { summarizeWaybillTracks } = require('./waybillEvents')

